import React from 'react';

import EventCTA from '../EventCTA';

import styles from './EventsSection.module.scss';

const { 'events-section-wrapper': eventsSectionClass, 'spacer-div': spacerDivClass } = styles;

const EventsSection = ({ eventsArray = [], onClick = () => {} }) => {
  return (
    <div className={eventsSectionClass}>
      {eventsArray.map(({ title, startDateISO, startTimeTBD }, idx) => (
        <EventCTA {...{ title, startDateISO, onClick, startTimeTBD }} key={idx} />
      ))}
      <div className={spacerDivClass} />
    </div>
  );
};

export default EventsSection;
